import { Auth } from 'aws-amplify';
import { CognitoUser } from '@aws-amplify/auth';

export interface CognitoUserAttributes {
  name?: string,
  surname?: string
}

type ProfileUserSession = {
  accessToken: {
    jwtToken: string,
  },
  idToken: {
    jwtToken: string,
  },
  refreshToken: {
    token: string,
  }
};

type CustomCognitoUser = CognitoUser & { signInUserSession: ProfileUserSession, attributes: CognitoUserAttributes };

export default async function getProfile(): Promise<undefined | string | CustomCognitoUser> {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (error) {
    console.log('error while retrieving user', error);
    if (error === 'The user is not authenticated') return 'The user is not authenticated';
    else return undefined;
  }
}